import { get } from "lodash";
import log from "loglevel";
import * as t from "./types";

export const getTeamReducerResponse = (
  state: any,
  responseType: string
): t.Team => {
  log.info("Getting Team from Store...");
  const value = get(state, `team.response.${responseType}`);
  return value;
};

export const getTeamsReducerResponse = (
  state: any,
  responseType: string
): t.Team[] => {
  log.info("Getting Teams from Store...");
  const value = get(state, `teams.response.${responseType}`);
  return value;
};

export const getTeamUsersReducerResponse = (
  state: any,
  responseType: string
): t.TeamUser[] => {
  log.info("Getting TeamUsers from Store...");
  const value = get(state, `teamUsers.response.${responseType}`);
  return value;
};
